import { ICON_COLORS } from './icons.constants'
import { IconProps } from './icons.types'

export const SequencesIcon = ({
  width = 18,
  height = 18,
  primaryColor = ICON_COLORS.PRIMARY.DEFAULT,
  secondaryColor = ICON_COLORS.SECONDARY.DEFAULT,
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_6097_27222)'>
        <path
          d='M0 10.125C0 10.1496 0 10.1707 0.00351563 10.1953C0.0316406 10.6242 0.298828 11.0004 0.692578 11.1656L4.63008 12.8074L5.625 13.2188V12.9375C5.625 12.7898 5.68477 12.6457 5.79023 12.5402L6.24727 12.0832C8.34258 9.98789 10.4379 7.89258 12.5332 5.80078C12.5367 5.79727 12.5402 5.79375 12.5402 5.79023C12.6457 5.68477 12.7793 5.63203 12.9164 5.625C13.0535 5.61797 13.1941 5.66367 13.3031 5.76211C13.4332 5.87812 13.5 6.03281 13.5 6.1875C13.5 6.30703 13.4613 6.42656 13.384 6.52852L7.875 13.6898V14.1539C8.57812 14.4457 9.28125 14.741 9.98438 15.0328C11.3871 15.6164 12.7898 16.2 14.1926 16.7871C14.5125 16.9207 14.8746 16.8996 15.177 16.7309C15.4793 16.5621 15.6867 16.2633 15.7395 15.9223L17.9895 1.29727C18.0562 0.871875 17.8699 0.442969 17.5148 0.200391C17.3215 0.0667969 17.1 0 16.875 0C16.6816 0 16.4918 0.0492187 16.316 0.147656L0.566016 9.14766C0.214453 9.34805 0 9.72422 0 10.125Z'
          fill={secondaryColor}
        />
        <path
          d='M13.384 6.53207C13.5633 6.29652 13.5316 5.96254 13.3102 5.76566C13.0887 5.56879 12.7512 5.57934 12.5402 5.79027L6.24727 12.0832L5.79023 12.5403C5.68477 12.6457 5.625 12.7899 5.625 12.9375V13.2188V15.1875V16.875C5.625 17.3391 5.90977 17.7539 6.33867 17.9227C6.76758 18.0914 7.25977 17.9789 7.57617 17.6379L9.98438 15.0364L7.875 14.1575V13.6934L13.384 6.53207Z'
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_6097_27222'>
          <rect
            width='18'
            height='18'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
